import { render, staticRenderFns } from "./InvestmentBalancePanel.vue?vue&type=template&id=76e9b16d&scoped=true"
import script from "./InvestmentBalancePanel.vue?vue&type=script&lang=ts"
export * from "./InvestmentBalancePanel.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentBalancePanel.vue?vue&type=style&index=0&id=76e9b16d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e9b16d",
  null
  
)

export default component.exports